/* eslint-disable max-len */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatRadioModule } from '@angular/material/radio';
import { RouterModule } from '@angular/router';
import { OrderModule } from '@features/order/order.module';
import { PollingModule } from '@features/polling/polling.module';
import { PromocodeModule } from '@features/promocode/promocode.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { KeywordFilterComponent } from '@rd/shared-legacy/components/keyword-filter/keyword-filter.component';
import { SharedSuccessButtonsComponent } from '@rd/shared-legacy/components/success-buttons/success-buttons.component';
import { SharedModule } from '@rd/shared-legacy/shared.module';
import { DatePickerModule } from '@rd/shared-legacy/widgets/date-picker/date-picker.module';
import { PromocodeUiComponent } from '@rd/shared-legacy/widgets/promocode-ui/promocode-ui.component';
import { TcV2CheckoutBannerComponent } from './components/checkout-banner/checkout-banner.component';
import { TcV2CheckoutFormComponent } from './components/checkout-form/checkout-form.component';
import { TcV2CheckoutLinkedAccountComponent } from './components/checkout-linked-account/checkout-linked-account.component';
import { TcV2CheckoutProgramDescriptionComponent } from './components/checkout-program-description/checkout-program-description.component';
import { TcV2CheckoutTermsListWrapperComponent } from './components/checkout-terms-list/checkout-terms-list-wrapper.component';
import { TcV2CheckoutTermsListComponent } from './components/checkout-terms-list/checkout-terms-list.component';
import { TcV2CheckoutTransferAmountFormComponent } from './components/checkout-transfer-amount-form/checkout-transfer-amount-form.component';
import { TcV2LinkAccountFormComponent } from './components/link-account-form/link-account-form.component';
import { TcV2LoyaltyProgramsCategoryFilterComponent } from './components/loyalty-programs-category-filter/loyalty-programs-category-filter.component';
import { TcV2LoyaltyProgramsListItemDesktopWrapperComponent } from './components/loyalty-programs-list-item-desktop/loyalty-programs-list-item-desktop-wrapper.component';
import { TcV2LoyaltyProgramsListItemDesktopComponent } from './components/loyalty-programs-list-item-desktop/loyalty-programs-list-item-desktop.component';
import { TcV2LoyaltyProgramsListItemMobileWrapperComponent } from './components/loyalty-programs-list-item-mobile/loyalty-programs-list-item-mobile-wrapper.component';
import { TcV2LoyaltyProgramsListItemMobileComponent } from './components/loyalty-programs-list-item-mobile/loyalty-programs-list-item-mobile.component';
import { TcV2LoyaltyProgramsListComponent } from './components/loyalty-programs-list/loyalty-programs-list.component';
import { TcV2MembershipDetailFormComponent } from './components/membership-detail-form/membership-detail-form.component';
import { TcV2MembershipFailDialogComponent } from './components/membership-fail-dialog/membership-fail-dialog.component';
import { TcV2MembershipSuccessDialogComponent } from './components/membership-success-dialog/membership-success-dialog.component';
import { TcV2ProgramsBannerWrapperComponent } from './components/programs-banner/programs-banner-wrapper.component';
import { TcV2ProgramsBannerComponent } from './components/programs-banner/programs-banner.component';
import { TcV2ReviewBodyComponent } from './components/review-body/review-body.component';
import { TcV2ReviewBreakdownComponent } from './components/review-breakdown/review-breakdown.component';
import { TcV2ReviewFormComponent } from './components/review-form/review-form.component';
import { TcV2SuccessDetailComponent } from './components/success-detail/success-detail.component';
import { TcV2SuccessPointsTransactionStatusComponent } from './components/success-points-transaction-status/success-points-transaction-status.component';
import { TcV2CheckoutLinkAccountDialogComponent } from './containers/checkout-link-account-dialog/checkout-link-account-dialog.component';
import { FormDataGuard } from './guards/form-data.guard';
import { TransferConnectV2SettingService } from './services/transfer-connect-v2-setting/transfer-connect-v2-setting.service';
import { CheckoutEffects } from './store/effects/checkout.effects';
import { LoyaltyProgramEffects } from './store/effects/loyalty-program.effects';
import { MembershipEffects } from './store/effects/membership.effects';
import { reducers } from './store/reducers/index';
import { TcV2CheckoutComponent } from './views/checkout/checkout.component';
import { TcV2ProgramsComponent } from './views/programs/programs.component';
import { TcV2ReviewComponent } from './views/review/review.component';
import { TcV2SuccessComponent } from './views/success/success.component';

/* eslint-enable max-len */

const declaredComponents: any[] = [
  TcV2CheckoutBannerComponent,
  TcV2CheckoutFormComponent,
  TcV2CheckoutLinkAccountDialogComponent,
  TcV2CheckoutLinkedAccountComponent,
  TcV2CheckoutProgramDescriptionComponent,
  TcV2CheckoutTermsListComponent,
  TcV2CheckoutTermsListWrapperComponent,
  TcV2CheckoutTransferAmountFormComponent,
  TcV2LoyaltyProgramsCategoryFilterComponent,
  TcV2LoyaltyProgramsListItemDesktopWrapperComponent,
  TcV2LoyaltyProgramsListItemDesktopComponent,
  TcV2LoyaltyProgramsListItemMobileWrapperComponent,
  TcV2LoyaltyProgramsListItemMobileComponent,
  TcV2LoyaltyProgramsListComponent,
  TcV2LinkAccountFormComponent,
  TcV2MembershipDetailFormComponent,
  TcV2MembershipFailDialogComponent,
  TcV2MembershipSuccessDialogComponent,
  TcV2ProgramsBannerComponent,
  TcV2ProgramsBannerWrapperComponent,
  TcV2ReviewBodyComponent,
  TcV2ReviewBreakdownComponent,
  TcV2ReviewFormComponent,
  TcV2SuccessDetailComponent,
  TcV2SuccessPointsTransactionStatusComponent,
];

const exportComponents: any[] = [
  TcV2CheckoutBannerComponent,
  TcV2CheckoutFormComponent,
  TcV2CheckoutLinkedAccountComponent,
  TcV2CheckoutTermsListComponent,
  TcV2CheckoutTermsListWrapperComponent,
  TcV2CheckoutProgramDescriptionComponent,
  TcV2LinkAccountFormComponent,
  TcV2LoyaltyProgramsCategoryFilterComponent,
  TcV2LoyaltyProgramsListComponent,
  TcV2CheckoutTransferAmountFormComponent,
  TcV2ProgramsBannerComponent,
  TcV2ReviewBodyComponent,
];

const views = [
  TcV2ProgramsComponent,
  TcV2CheckoutComponent,
  TcV2ReviewComponent,
  TcV2SuccessComponent,
];

@NgModule({
  declarations: [...declaredComponents, ...views],
  imports: [
    CommonModule,
    SharedSuccessButtonsComponent,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatSlideToggleModule,
    RouterModule,
    SharedModule,
    DatePickerModule,
    PromocodeUiComponent,
    StoreModule.forFeature('transferConnectV2', reducers),
    EffectsModule.forFeature([
      CheckoutEffects,
      LoyaltyProgramEffects,
      MembershipEffects,
    ]),
    KeywordFilterComponent,
    PromocodeModule,
    OrderModule,
    PollingModule,
  ],
  exports: [SharedModule, ...exportComponents],
  providers: [FormDataGuard, TransferConnectV2SettingService],
})
export class TransferConnectV2Module {}
